import dynamic from "next/dynamic";

import shareQuery from "../../../ParagraphsAndBlocks/Share/query";
import brMainMenuQuery from "../../../ParagraphsAndBlocks/BRMainMenu/query";
import footerMenuQuery from "../../../ParagraphsAndBlocks/FooterMenu/query";
import bigSliderQuery from "../../../ParagraphsAndBlocks/BigSlider/query";
import betCalculator from "../../../ParagraphsAndBlocks/BetCalculator/query";
import marginCalculator from "../../../ParagraphsAndBlocks/MarginCalculator/query";
import arbitrageCalculator from "../../../ParagraphsAndBlocks/ArbitrageCalculator/query";
import oddsCalculator from "../../../ParagraphsAndBlocks/OddsCalculator/query";
import basicBlock from "../../../ParagraphsAndBlocks/BasicBlock/query";
import basicBlockTabs from "../../../ParagraphsAndBlocks/BasicBlockTabs/query";
import customLinksList from "../../../ParagraphsAndBlocks/CustomLinksList/query";
import glossary from "../../../ParagraphsAndBlocks/Glossary/query";
import promotionBlock from "../../../ParagraphsAndBlocks/PromotionBlock/query";
import latest from "../../../ParagraphsAndBlocks/Latest/query";
import userLatestListing from "../../../container/UserLaTestSection/query";
import related from "../../../ParagraphsAndBlocks/Related/query";
import news from "../../../ParagraphsAndBlocks/News/query";
import podcasts from "../../../ParagraphsAndBlocks/Podcasts/query";
import popular from "../../../ParagraphsAndBlocks/Popular/query";
import categories from "../../../ParagraphsAndBlocks/Categories/query";
import video from "../../../ParagraphsAndBlocks/Video/query";
import headerParagraph from "../../../ParagraphsAndBlocks/HeaderParagraph/query";
import latestSingleRecord from "../../../ParagraphsAndBlocks/LatestSingleRecord/query";
import catBlock from "../../../ParagraphsAndBlocks/CtaBlock/query";
import authorsListing from "../../../ParagraphsAndBlocks/AuthorsListing/query";
import seriesCarousel from "../../../ParagraphsAndBlocks/AllSeriesCarousel/query";
import freeText from "../../../ParagraphsAndBlocks/FreeText/query";
import latestVideos from "../../../ParagraphsAndBlocks/LatestVideos/query";
import shareThis from "../../../ParagraphsAndBlocks/ShareThis/query";
import smallPromotion from "../../../ParagraphsAndBlocks/SmallPromotion/query";
import questionAnswerSection from "../../../ParagraphsAndBlocks/QuestionAnswerSection/query";
import searchLibrary from "../../../ParagraphsAndBlocks/SearchLibrary/query";
import blocksParagraph from "../../../ParagraphsAndBlocks/BlocksParagraph/query";
import sidebarPredictions from "../../../ParagraphsAndBlocks/SidebarPredictions/query";
import tagsPredictions from "../../../ParagraphsAndBlocks/TagsParagraph/query";
import twitterBlockParagraph from "../../../ParagraphsAndBlocks/TwitterBlockParagraph/query";
// import predictions from "../../../ParagraphsAndBlocks/Predictions/query";

const ShareComponent = dynamic(() => import("../../../ParagraphsAndBlocks/Share"), {
	ssr: false,
});
const BRMainMenuComponent = dynamic(() => import("../../../ParagraphsAndBlocks/BRMainMenu"), {
	ssr: false,
});
const FooterMenuComponent = dynamic(() => import("../../../ParagraphsAndBlocks/FooterMenu"), {
	ssr: false,
});
const BigSliderComponent = dynamic(() => import("../../../ParagraphsAndBlocks/BigSlider"), {
	ssr: false,
});
const BetCalculator = dynamic(() => import("../../../ParagraphsAndBlocks/BetCalculator"), {
	ssr: false,
});
const MarginCalculator = dynamic(() => import("../../../ParagraphsAndBlocks/MarginCalculator"), {
	ssr: false,
});
const ArbitrageCalculator = dynamic(() => import("../../../ParagraphsAndBlocks/ArbitrageCalculator"), {
	ssr: false,
});
const OddsCalculator = dynamic(() => import("../../../ParagraphsAndBlocks/OddsCalculator"), {
	ssr: false,
});
const CustomLinksList = dynamic(() => import("../../../ParagraphsAndBlocks/CustomLinksList"), {
	ssr: false,
});
const BasicBlock = dynamic(() => import("../../../ParagraphsAndBlocks/BasicBlock"), {
	ssr: false,
});
const BasicBlockTabs = dynamic(() => import("../../../ParagraphsAndBlocks/BasicBlockTabs"), {
	ssr: false,
});
const PromotionBlock = dynamic(() => import("../../../ParagraphsAndBlocks/PromotionBlock"), {
	ssr: false,
});
const Glossary = dynamic(() => import("../../../ParagraphsAndBlocks/Glossary"), {
	ssr: false,
});
const Latest = dynamic(() => import("../../../ParagraphsAndBlocks/Latest"), {
	ssr: false,
});
const UserLatestListing = dynamic(() => import("../../../ParagraphsAndBlocks/UserLatestListing"), {
	ssr: false,
});
const Related = dynamic(() => import("../../../ParagraphsAndBlocks/Related"), {
	ssr: false,
});
const News = dynamic(() => import("../../../ParagraphsAndBlocks/News"), {
	ssr: false,
});
const Podcasts = dynamic(() => import("../../../ParagraphsAndBlocks/Podcasts"), {
	ssr: false,
});
const Popular = dynamic(() => import("../../../ParagraphsAndBlocks/Popular"), {
	ssr: false,
});
const Categories = dynamic(() => import("../../../ParagraphsAndBlocks/Categories"), {
	ssr: false,
});
const Video = dynamic(() => import("../../../ParagraphsAndBlocks/Video"), {
	ssr: false,
});
const HeaderParagraph = dynamic(() => import("../../../ParagraphsAndBlocks/HeaderParagraph"), {
	ssr: false,
});
const LatestSingleRecord = dynamic(() => import("../../../ParagraphsAndBlocks/LatestSingleRecord"), {
	ssr: false,
});
const CTABlock = dynamic(() => import("../../../ParagraphsAndBlocks/CtaBlock"), {
	ssr: false,
});
const AuthorsListing = dynamic(() => import("../../../ParagraphsAndBlocks/AuthorsListing"), {
	ssr: false,
});
const SeriesCarousel = dynamic(() => import("../../../ParagraphsAndBlocks/AllSeriesCarousel"), {
	ssr: false,
});
const FreeText = dynamic(() => import("../../../ParagraphsAndBlocks/FreeText"), {
	ssr: false,
});
const LatestVideos = dynamic(() => import("../../../ParagraphsAndBlocks/LatestVideos"), {
	ssr: false,
});
const ShareThis = dynamic(() => import("../../../ParagraphsAndBlocks/ShareThis"), {
	ssr: false,
});
const SmallPromotion = dynamic(() => import("../../../ParagraphsAndBlocks/SmallPromotion"), {
	ssr: false,
});
const QuestionAnswerSection = dynamic(() => import("../../../ParagraphsAndBlocks/QuestionAnswerSection"), {
	ssr: false,
});
const SearchLibrary = dynamic(() => import("../../../ParagraphsAndBlocks/SearchLibrary"), {
	ssr: false,
});
const BlocksParagraph = dynamic(() => import("../../../ParagraphsAndBlocks/BlocksParagraph"), {
	ssr: false,
});
const BlocksHeadingParagraph = dynamic(() => import("../../../ParagraphsAndBlocks/BlocksParagraph/BlocksHeading"), {
	ssr: false,
});
const BlocksBottomParagraph = dynamic(() => import("../../../ParagraphsAndBlocks/BlocksParagraph/BlocksBottom"), {
	ssr: false,
});
const SidebarPredictionsBlock = dynamic(() => import("../../../ParagraphsAndBlocks/SidebarPredictions"), {
	ssr: false,
});
const TagsPredictions = dynamic(() => import("../../../ParagraphsAndBlocks/TagsParagraph"), {
	ssr: false,
});
const TwiterBlockParagraph = dynamic(() => import("../../../ParagraphsAndBlocks/TwitterBlockParagraph"), {
	ssr: false,
});

interface iComponents {
	[key: string]: {
		component: any;
		query: any;
		subtype?: any;
		withPagination: boolean;
	};
}

/* eslint-disable camelcase */
const components: iComponents = {
	componentName: {
		component: ShareComponent,
		query: shareQuery,
		withPagination: true,
	}, // Just as Example
	br_main_menu: {
		component: BRMainMenuComponent,
		query: brMainMenuQuery,
		withPagination: false,
	},
	footer_menu: {
		component: FooterMenuComponent,
		query: footerMenuQuery,
		withPagination: false,
	},
	field_mainstage: {
		component: BigSliderComponent,
		query: bigSliderQuery,
		withPagination: false,
	},
	bet_calculator: {
		component: BetCalculator,
		query: betCalculator,
		withPagination: false,
	},
	margin_calculator: {
		component: MarginCalculator,
		query: marginCalculator,
		withPagination: false,
	},
	arbitrage_calculator: {
		component: ArbitrageCalculator,
		query: arbitrageCalculator,
		withPagination: false,
	},
	odds_converter_calculator: {
		component: OddsCalculator,
		query: oddsCalculator,
		withPagination: false,
	},
	basic: {
		component: BasicBlock,
		query: basicBlock,
		withPagination: false,
	},
	basic_w_tabs: {
		component: BasicBlockTabs,
		query: basicBlockTabs,
		withPagination: false,
	},
	promotion_block: {
		component: PromotionBlock,
		query: promotionBlock,
		withPagination: false,
	},
	glossary: {
		component: Glossary,
		query: glossary,
		withPagination: false,
	},
	latest_listing: {
		component: Latest,
		query: latest,
		withPagination: false,
	},
	user_latest_listing: {
		component: UserLatestListing,
		query: userLatestListing,
		withPagination: false,
	},
	related: {
		component: Related,
		query: related,
		withPagination: false,
	},
	featured_news: {
		component: News,
		query: news,
		withPagination: false,
	},
	podcasts: {
		component: Podcasts,
		query: podcasts,
		withPagination: false,
	},
	popular: {
		component: Popular,
		query: popular,
		withPagination: false,
	},
	categories: {
		component: Categories,
		query: categories,
		withPagination: false,
	},
	featured_videos: {
		component: Video,
		query: video,
		withPagination: false,
	},
	authors_listing: {
		component: AuthorsListing,
		query: authorsListing,
		withPagination: false,
	},
	heading: {
		component: HeaderParagraph,
		query: headerParagraph,
		withPagination: false,
	},
	latest_single_record: {
		component: LatestSingleRecord,
		query: latestSingleRecord,
		withPagination: false,
	},
	series_carousel: {
		component: SeriesCarousel,
		query: seriesCarousel,
		withPagination: false,
	},
	free_text: {
		component: FreeText,
		query: freeText,
		withPagination: false,
	},
	cta_block: {
		component: CTABlock,
		query: catBlock,
		withPagination: false,
	},
	links_block: {
		component: CustomLinksList,
		query: customLinksList,
		withPagination: false,
	},
	latest_videos: {
		component: LatestVideos,
		query: latestVideos,
		withPagination: false,
	},
	share_this: {
		component: ShareThis,
		query: shareThis,
		withPagination: false,
	},
	small_promotion_block: {
		component: SmallPromotion,
		query: smallPromotion,
		withPagination: false,
	},
	q_a_block: {
		component: QuestionAnswerSection,
		query: questionAnswerSection,
		withPagination: false,
	},
	search: {
		component: SearchLibrary,
		query: searchLibrary,
		withPagination: false,
	},
	blocks: {
		component: BlocksParagraph,
		query: blocksParagraph,
		withPagination: false,
		subtype: {
			heading: BlocksHeadingParagraph,
			bottom: BlocksBottomParagraph,
		},
	},
	predictions: {
		component: SidebarPredictionsBlock,
		query: sidebarPredictions,
		withPagination: false,
	},
	latest_listing_by_a_tag: {
		component: TagsPredictions,
		query: tagsPredictions,
		withPagination: false,
	},
	twitter_block_paragraph: {
		component: TwiterBlockParagraph,
		query: twitterBlockParagraph,
		withPagination: false,
	},
};

const getParagraphInfo = (machineName: string) => {
	if (!components[machineName]) {
		console.log(`Paragraph "${machineName}" does not exist`);
	}
	return components[machineName];
};

export default getParagraphInfo;
